import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { RoleGuardService } from "./services/role-guard.service";

export const appRoutes: Routes = [
    { 
        path: '', 
        loadComponent: ()=> import('./login-home/home/home.component').then(m=>m.HomeComponent), 
        canActivate: [MsalGuard],
        children: [
            { 
                path: '', 
                pathMatch: 'full',
                redirectTo: ''
            },
            { 
                path: 'refundable/search', 
                loadComponent: ()=> import('./refundable/refund-search/refund-search.component').then(m=>m.RefundSearchComponent),
                canActivate: [RoleGuardService],
                data: { 
                    expectedRole: "AuthSearchRefundEditor,AuthSearchRefundApprover,AuthReadOnly"
                }
            },
            { 
                path: 'refundable/refund',
                loadComponent: ()=> import('./refundable/refund/refund.component').then(m=>m.RefundComponent) 
            },
            { 
                path: 'refundable/group-information', 
                loadComponent: ()=>import('./refundable/group-information/group-information.component').then(m=>m.GroupInformationComponent)
            }
        ]
    }
];